import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret, faFileExcel } from '@fortawesome/free-solid-svg-icons'
import { faTimesCircle, faBuilding } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUserSecret, faFileExcel, faTimesCircle, faBuilding)

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
